module.exports = __webpack_public_path__ + "static/img/logo.16a213e7.png";